module.exports = __webpack_public_path__ + "static/media/alignment-bg.cea4a0f4.svg";